/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RateResponseStatus } from './RateResponseStatus';
import {
    RateResponseStatusFromJSON,
    RateResponseStatusFromJSONTyped,
    RateResponseStatusToJSON,
    RateResponseStatusToJSONTyped,
} from './RateResponseStatus';

/**
 * 
 * @export
 * @interface RateSourceStatus
 */
export interface RateSourceStatus {
    /**
     * 
     * @type {string}
     * @memberof RateSourceStatus
     */
    rateSource: RateSourceStatusRateSourceEnum;
    /**
     * 
     * @type {RateResponseStatus}
     * @memberof RateSourceStatus
     */
    status: RateResponseStatus;
}


/**
 * @export
 */
export const RateSourceStatusRateSourceEnum = {
    Direct: 'direct',
    Travelport: 'travelport',
    Liteapi: 'liteapi'
} as const;
export type RateSourceStatusRateSourceEnum = typeof RateSourceStatusRateSourceEnum[keyof typeof RateSourceStatusRateSourceEnum];


/**
 * Check if a given object implements the RateSourceStatus interface.
 */
export function instanceOfRateSourceStatus(value: object): value is RateSourceStatus {
    if (!('rateSource' in value) || value['rateSource'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function RateSourceStatusFromJSON(json: any): RateSourceStatus {
    return RateSourceStatusFromJSONTyped(json, false);
}

export function RateSourceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateSourceStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'rateSource': json['rate_source'],
        'status': RateResponseStatusFromJSON(json['status']),
    };
}

export function RateSourceStatusToJSON(json: any): RateSourceStatus {
    return RateSourceStatusToJSONTyped(json, false);
}

export function RateSourceStatusToJSONTyped(value?: RateSourceStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rate_source': value['rateSource'],
        'status': RateResponseStatusToJSON(value['status']),
    };
}

